import { render, staticRenderFns } from "./Dayi.vue?vue&type=template&id=1e17576e&scoped=true&"
import script from "./Dayi.vue?vue&type=script&lang=js&"
export * from "./Dayi.vue?vue&type=script&lang=js&"
import style0 from "./Dayi.vue?vue&type=style&index=0&id=1e17576e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e17576e",
  null
  
)

export default component.exports